import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    Button,
    Col,
    Container,
    Row,
    Form,
    Table,
    Overlay,
    Popover,
} from "react-bootstrap";
import calendarIcon from "../../Assets/Images/Revenue-management/calendarIcon.svg";
import horizobtalBarIcon from "../../Assets/Images/Revenue-management/horizontal-bars.svg";
import ticket from "../../Assets/Images/Revenue-management/ticket.svg";
import reload from "../../Assets/Images/Revenue-management/blue-reload.svg";
import reloadYellow from "../../Assets/Images/Revenue-management/reloadIconyellow.svg";
import reloadGreen from "../../Assets/Images/Revenue-management/reloadIcongreen.svg";
import alarm from "../../Assets/Images/Revenue-management/alarm.svg";
import premonth from "../../Assets/Images/Revenue-management/preMonth.svg";
import nextmonth from "../../Assets/Images/Revenue-management/nextMonth.svg";
import dateVerticalThreeDot from "../../Assets/Images/dateVerticalThreeDot.svg";
import graphIcon from "../../Assets/Images/Revenue-management/graphIcon.svg";
import ToolsSingleTicketPopUp from "../CommonComponent/ToolsSingleTicketPopUp";
import { Link } from "react-router-dom";
import Loader from "../Loader/Loader";
import AddCompetitorModal from "./AddCompetitorModal";
import ToolsSummaryModalByFilter from "./ToolsSummaryModalByFilter";
import GroupReservationsModal from "./GroupReservationsModal";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import placeHolder from "../../Assets/Images/Revenue-management/no-img.png";
import moment from "moment";
import { commonService } from "../../utils/commonService";
import { useSelector } from "react-redux";
import AddEventModal from "./propertySetting/AddEventModal";
import AddReminderModal from "./AddReminderModal";
import soldOutIcon from "../../Assets/Images/Revenue-management/soldout.svg";
import EventViewModal from "../CommonComponent/EventViewModal";
import RateShopGraphView from "./RateShopGraphView";
import Non_WidgetDetailModal from "./NonWidgetDetailModal";
import infoIcon from "../../Assets/Images/Action Icons/infoIcon..svg";
import downloadIcon from "../../Assets/Images/Operation/downloadIcon.svg";
import { compsetTypeList, noOfGuestsList, noOfNightsList, ratemetricsRoomtypes, validationRule } from "../../utils/constant";
import { checkValidation } from "../../utils/helper";
import OnDemandRateshopRequestStatusModal from "./propertySetting/OnDemandRateshopRequestStatusModal";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { toast } from "react-toastify";

function RMRateShop({ api, para, setting }) {
    const [requestStatusModal, setRequestStatusModal] = useState(false);

    const [widgetModal, setWidgetModal] = useState(false);
    const [tblids, settblids] = useState({
        RateShopTable: commonService.GenerateGUID(),
    });
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [showToolsSummaryPopUp, setToolsSummaryPopUp] = useState(false);
    const dateRef = useRef();
    const handleToolsSummaryPopUp = () => {
        setToolsSummaryPopUp(true);
    };
    const closeToolsSummaryPopUp = () => {
        setToolsSummaryPopUp(false);
    };
    const [showAddCompetitorModal, setAddCompetitorModal] = useState(false);
    const [showGroupReservationModal, setGroupReservationModal] = useState(false);
    const [CompetitordataId, setCompetitordataId] = useState(0);

    const handleAddCompetitorModal = () => {
        setAddCompetitorModal(true);
    };

    const closeAddCompetitorModal = () => {
        setAddCompetitorModal(false);
    };
    const [showToolsSummaryModal, setToolsSummaryModal] = useState(false);
    // const handleToolsSummaryModal = () => {
    //   setToolsSummaryModal(true);
    // };

    const [AllChannels, setAllChannels] = useState([]);



    const closeToolsSummaryModal = () => {
        setToolsSummaryModal(false);
    };
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const [showSingleTicketPopUp, setShowSingleTicketPopUp] = useState(false);
    const clikedDateRef = useRef();

    const closeSingleTicketPopUp = () => {
        setShowSingleTicketPopUp(false);
    };

    const [showModal, setShowModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });


    const [ShowToolTip, setShowToolTip] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
        Date: "",
        Data: {}
    });

    const handleFilterBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setShowModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const closeSingleDate = () => {
        setShowModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const [dotPopUp, setdotPopUp] = useState({ top: 0, left: 0 });
    const [showDotsPopup, setshowDotsPopup] = useState(false);
    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);

    const handleDotsClick = (event) => {
        const calendarTable = document.getElementById("fullCustomTableCalendar");
        const ticketPopupPosition = calendarTable.getBoundingClientRect();
        const td = event.currentTarget;
        td.style.backgroundColor = "red";
        const tdRect = td.getBoundingClientRect();

        const tdCenterX = tdRect.left + tdRect.width / 2 - ticketPopupPosition.left;
        const tdCenterY =
            tdRect.top + tdRect.height / 2 - ticketPopupPosition.top + 13;

        const popupTop = tdCenterY + window.scrollY;
        const popupLeft = tdCenterX + window.scrollX;

        setdotPopUp({ top: popupTop, left: popupLeft });
        setshowDotsPopup(true);
    };

    const closedotPopUp = () => {
        setshowDotsPopup(false);
    };

    const [showGroupReservationsModal, setGroupReservationsModal] =
        useState(false);
    const handleGroupReservationsModal = () => {
        setGroupReservationsModal(true);
    };

    const closeGroupReservationsModal = () => {
        setGroupReservationsModal(false);
    };

    const date = new Date();
    const startDate = commonService.getDateInDBFormat(
        new Date(date.getFullYear(), date.getMonth(), 1)
    );
    const endDate = commonService.getDateInDBFormat(
        new Date(date.getFullYear(), date.getMonth() + 1, 0)
    );

    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const [currentDate, setCurrentDate] = useState(new Date());
    const [competitorList, setCompetitorList] = useState([]);
    const [colorComparisonData, setColorComparisonData] = useState(null);
    const [selectedCompetitorList, setSelectedCompetitorList] = useState(null);
    const selectedCompetitorListRef = useRef();
    const [rateShopList, setRateShopList] = useState(null);
    const rateShopListRef = useRef();
    const rateShopRequestTrackerRef = useRef({ key: "", inFlight: false });
    const [diffType, setDiffType] = useState("avg");
    const [Compare, setCompare] = useState(1);

    const [RateshopPara, setRateshopPara] = useState({
        ChannelName: "",
        Channel: "",
        Night: "1",
        Guest: "2",
        RoomType: "",
        CompSetType: "",
        RateShopConfigType: "",
    });

    const [dateRange, setDateRange] = useState({
        start: commonService.convertDateInTimezone(startDate),
        end: commonService.convertDateInTimezone(endDate),
    });
    const [ClickedDate, setClickedDate] = useState(new Date());
    const [showEventModal, setShowEventModal] = useState(false);
    const [showReminderModal, setShowReminderModal] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const propertyCode = para?.propertyCode || para?.PropertyCode || para?.propertycode || propertyDetailFromRTK?.propertycode || "";
    const propertyId = para?.propertyId || para?.PropertyId || para?.propertyid || propertyDetailFromRTK?.propertyid || 0;
    const [showTicketModal, setShowTicketModal] = useState(false);
    const [callApi, setCallApi] = useState(false);
    const eventListRef = useRef();
    const reminderListRef = useRef();
    // Performance: keep state copies so calendar indexes can be memoized.
    const [eventListData, setEventListData] = useState([]);
    const [reminderListData, setReminderListData] = useState([]);
    const isReminderRef = useRef();
    const eventListPropsRef = useRef();
    const reminderListPropsRef = useRef();
    const selectedEventDateRef = useRef();
    const [soldOutList, setSoldOutList] = useState(null);
    const isRateShopSoldOutRef = useRef();
    const [rateShopForecastData, setRateShopForecastData] = useState(null);

    const [viewReminderModal, setViewReminderModal] = useState(false);
    const [showAdrChart, setShowAdrChart] = useState(false);
    const closeViewReminderModal = () => {
        setViewReminderModal(false);
    };
    const closeAdrChart = () => {
        setShowAdrChart(false);
    };

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };

    const closeReminderModal = () => {
        setShowReminderModal(false);
        setCallApi(!callApi);
    };

    const closeEventModal = () => {
        setShowEventModal(false);
        setCallApi(!callApi);
    };

    const getDaysInMonth = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        return new Date(year, month + 1, 0).getDate();
    };

    const getFirstDayOfMonth = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        return new Date(year, month, 1).getDay();
    };

    function GetRateshopCalendarCellColor(per) {
        if (per <= 5) {
            return "rgb(234, 226, 183, 0.1)";
        } else if (per <= 10) {
            return "rgb(234, 226, 183, 0.2)";
        } else if (per <= 15) {
            return "rgb(234, 226, 183, 0.3)";
        } else if (per <= 20) {
            return "rgb(234, 226, 183, 0.4)";
        } else if (per <= 25) {
            return "rgb(234, 226, 183, 0.5)";
        } else if (per <= 30) {
            return "rgb(234, 226, 183, 0.6)";
        } else if (per <= 35) {
            return "rgb(234, 226, 183, 0.7)";
        } else if (per <= 40) {
            return "rgb(234, 226, 183, 0.8)";
        } else if (per <= 45) {
            return "rgb(234, 226, 183, 0.9)";
        } else if (per <= 50) {
            return "rgb(234, 226, 183, 1)";
        } else if (per <= 54) {
            return "rgb(252, 191, 73, 0.2)";
        } else if (per <= 58) {
            return "rgb(252, 191, 73, 0.4)";
        } else if (per <= 62) {
            return "rgb(252, 191, 73, 0.6)";
        } else if (per <= 66) {
            return "rgb(252, 191, 73, 0.8)";
        } else if (per <= 70) {
            return "rgb(252, 191, 73, 1)";
        } else if (per <= 74) {
            return "rgb(247, 127, 0, 0.2)";
        } else if (per <= 78) {
            return "rgb(247, 127, 0, 0.4)";
        } else if (per <= 82) {
            return "rgb(247, 127, 0, 0.6)";
        } else if (per <= 86) {
            return "rgb(247, 127, 0, 0.8)";
        } else if (per <= 90) {
            return "rgb(247, 127, 0, 1)";
        } else if (per === 91) {
            return "rgb(214, 40, 40, 0.1)";
        } else if (per === 92) {
            return "rgb(214, 40, 40, 0.2)";
        } else if (per === 93) {
            return "rgb(214, 40, 40, 0.3)";
        } else if (per === 94) {
            return "rgb(214, 40, 40, 0.4)";
        } else if (per === 95) {
            return "rgb(214, 40, 40, 0.5)";
        } else if (per === 96) {
            return "rgb(214, 40, 40, 0.6)";
        } else if (per === 97) {
            return "rgb(214, 40, 40, 0.7)";
        } else if (per === 98) {
            return "rgb(214, 40, 40, 0.8)";
        } else if (per === 99) {
            return "rgb(214, 40, 40, 0.9)";
        } else if (per >= 100) {
            return "rgb(214, 40, 40, 1)";
        }
    }

    const renderCalendar = (calDate) => {
        const calendar = [];
        let MonthFirstDate = new Date(calDate.getFullYear(), calDate.getMonth(), 1);
        let MonthLastDate = new Date(
            calDate.getFullYear(),
            calDate.getMonth() + 1,
            0
        );

        let CalFirstDate = new Date(calDate.getFullYear(), calDate.getMonth(), 1);
        CalFirstDate = new Date(
            CalFirstDate.setDate(CalFirstDate.getDate() - CalFirstDate.getDay())
        );

        for (let i = 0; i < 6; i++) {
            const row = [];
            for (let j = 0; j < 7; j++) {
                let DTDate = commonService.convertDateInTimezone(CalFirstDate);
                let borderColor = "",
                    showBorder = false,
                    style = "",
                    showThreeDot = false;

                // let style = showBorder ? borderColor : "";

                const dateKey = calendarDateKey(DTDate);
                let findOccPercenatge = forecastByDate[dateKey] || [];
                let checkEvent = eventsByDate[dateKey] || [];
                let checkReminder = remindersByDate[dateKey] || [];
                let checkSoldOut = soldOutByDate[dateKey] || [];

                if (CalFirstDate >= MonthFirstDate && MonthFirstDate <= MonthLastDate) {
                    if (diffType === "avg") {
                        if (
                            rateShopList[CalFirstDate.getDate()]?.total > 0 &&
                            rateShopList[CalFirstDate.getDate()]?.isSelf?.rate > 0
                        ) {
                            let avg =
                                rateShopList[CalFirstDate.getDate()]?.total /
                                rateShopList[CalFirstDate.getDate()]?.lengthForAvg;
                            let findDiffFromCal =
                                // avg - rateShopList[CalFirstDate.getDate()]?.isSelf?.rate;
                                rateShopList[CalFirstDate.getDate()]?.isSelf?.rate - avg;
                            let percentage = Math.round(
                                (findDiffFromCal * 100) /
                                rateShopList[CalFirstDate.getDate()]?.isSelf?.rate
                            );
                            showBorder = true;
                            style = showBorder ? getComparisonColor(percentage, true) : "";
                        }
                    } else if (diffType === "max") {
                        if (
                            rateShopList[CalFirstDate.getDate()]?.max > 0 &&
                            rateShopList[CalFirstDate.getDate()]?.isSelf?.rate > 0
                        ) {
                            // let findDiffFromCal =
                            //   rateShopList[CalFirstDate.getDate()]?.max -
                            //   rateShopList[CalFirstDate.getDate()]?.isSelf?.rate;
                            let findDiffFromCal =
                                rateShopList[CalFirstDate.getDate()]?.isSelf?.rate -
                                rateShopList[CalFirstDate.getDate()]?.max;

                            let percentage = Math.round(
                                (findDiffFromCal * 100) /
                                rateShopList[CalFirstDate.getDate()]?.isSelf?.rate
                            );
                            showBorder = true;
                            style = showBorder ? getComparisonColor(percentage, true) : "";
                        }
                    } else if (diffType === "min") {
                        if (
                            rateShopList[CalFirstDate.getDate()]?.min > 0 &&
                            rateShopList[CalFirstDate.getDate()]?.isSelf?.rate > 0
                        ) {
                            // let findDiffFromCal =
                            //   rateShopList[CalFirstDate.getDate()]?.min -
                            //   rateShopList[CalFirstDate.getDate()]?.isSelf?.rate;
                            let findDiffFromCal =
                                rateShopList[CalFirstDate.getDate()]?.isSelf?.rate -
                                rateShopList[CalFirstDate.getDate()]?.min;

                            let percentage = Math.round(
                                (findDiffFromCal * 100) /
                                rateShopList[CalFirstDate.getDate()]?.isSelf?.rate
                            );
                            showBorder = true;
                            style = showBorder ? getComparisonColor(percentage, true) : "";
                        }
                    }
                }

                let checkRequest = [];

                let RequestStatus = reload;
                let RequestTitle = "Request For Rate";

                if (requestList && requestList.length > 0) {
                    const requestTitle = (commonService.getConvertDateInTimeZone(DTDate) + " Night : " + parseInt(RateshopPara.Night) + " Guest : " + parseInt(RateshopPara.Guest) + " Channel : " + RateshopPara.ChannelName).toUpperCase();
                    const request = requestByTitle[requestTitle];
                    if (request) {
                        checkRequest = [request];
                        if (String(request.requeststatus || "").toUpperCase() === "COMPLETED") {
                            RequestStatus = reloadGreen;
                            RequestTitle = "Request is Completed";
                        } else if (String(request.requeststatus || "").toUpperCase() === "QUEUED") {
                            RequestStatus = reloadYellow;
                            RequestTitle = "Request in Queue";
                        }
                    }
                }

                let IsOnDemandLoading = onDemandLoadingByDate[commonService.getDateInDBFormat(DTDate)] || [];

                let CurrentDateMinone = new Date();
                CurrentDateMinone = new Date(CurrentDateMinone);
                CurrentDateMinone = CurrentDateMinone.setDate(CurrentDateMinone.getDate() - 1);
                CurrentDateMinone = new Date(CurrentDateMinone);
                let colorOpacity = findOccPercenatge?.[0]?.OCC_Percentage
                    ? (findOccPercenatge?.[0]?.OCC_Percentage / 100)?.toFixed(1)
                    : 0;

                row.push(
                    <td
                        key={`${i}-${j}`}
                        className={`main-date-box-with-bg my-custom-width-td color-opacity ${CalFirstDate?.getMonth() !== calDate.getMonth()
                            ? "disableDate"
                            : ""
                            } ${commonService.getDateInDBFormat(CalFirstDate) ===
                                commonService.getDateInDBFormat(new Date())
                                ? "today todayDate"
                                : ""
                            }`}
                        style={{
                            borderBottom: style,
                            background: GetRateshopCalendarCellColor(
                                findOccPercenatge?.[0]?.OCC_Percentage
                            ),
                        }}

                        data_CalFirstDate={commonService.getDateInDBFormat(CalFirstDate) + " 00:00:00"}
                        data_calDate={commonService.getDateInDBFormat(calDate) + " 00:00:00"}

                        onMouseEnter={(e) => {
                            const data_CalFirstDate = e.currentTarget.getAttribute("data_CalFirstDate");
                            const data_calDate = e.currentTarget.getAttribute("data_calDate");
                            if (new Date(data_CalFirstDate).getMonth() === new Date(data_calDate).getMonth()) {
                                const targetRect = e.currentTarget.getBoundingClientRect();
                                const topSpace = targetRect.top;
                                let Position = "bottom";
                                if (topSpace + 300 > window.innerHeight) {
                                    Position = "top";
                                }

                                if (new Date(data_CalFirstDate).getDate() > 0 && rateShopList) {
                                    const Data = rateShopList[new Date(data_CalFirstDate).getDate()]
                                    if (Data) {
                                        setShowToolTip({
                                            IsDisplay: true,
                                            Target: e.currentTarget,
                                            Position: Position,
                                            Date: data_CalFirstDate,
                                            Data: Data
                                        });
                                    } else {
                                        setShowToolTip({
                                            IsDisplay: false,
                                            Target: null,
                                            Position: "top",
                                            Date: "",
                                            Data: {}
                                        });
                                    }
                                }
                            }
                            else {
                                setShowToolTip({
                                    IsDisplay: false,
                                    Target: null,
                                    Position: "top",
                                    Date: "",
                                    Data: {}
                                });
                            }
                        }}
                    >
                        <div className="temp-calendar-td">
                            {checkSoldOut?.length > 0 ? (
                                <>
                                    <div className="main-date-box-inner">
                                        <p>{CalFirstDate.getDate()}</p>
                                        {CalFirstDate?.getMonth() == calDate.getMonth() && (
                                            <img id={commonService.generateGlobalClickTrackerID("RMRateShop", "checksoldout-dateverticalthreedot", "")}
                                                src={dateVerticalThreeDot}
                                                onClick={(e) => {
                                                    if (
                                                        moment(clikedDateRef.current).format(
                                                            "YYYY-MM-DD"
                                                        ) === moment(DTDate).format("YYYY-MM-DD")
                                                    ) {
                                                        isRateShopSoldOutRef.current = checkSoldOut;
                                                        clikedDateRef.current = "";
                                                        closeSingleDate();
                                                    } else {
                                                        isRateShopSoldOutRef.current = checkSoldOut;
                                                        clikedDateRef.current = DTDate;
                                                        handleFilterBtnClick(e);
                                                    }
                                                }}
                                                alt="dateVerticalThreeDot"
                                            />
                                        )}
                                    </div>

                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <img src={soldOutIcon} alt="soldOut" />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="main-date-box-inner">
                                        <p>
                                            {CalFirstDate.getDate()}
                                        </p>
                                        <div className="main-date-box-all-icons">
                                            {
                                                IsOnDemandLoading && IsOnDemandLoading.length > 0 ?
                                                    <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></>
                                                    :
                                                    <>
                                                        {CalFirstDate?.getMonth() === calDate.getMonth() && (
                                                            <>
                                                                {
                                                                    checkRequest && checkRequest.length > 0 ?
                                                                        <img id={commonService.generateGlobalClickTrackerID("RMRateShop", "refresh-RequestTitle", "")}
                                                                            src={RequestStatus}
                                                                            title={RequestTitle}
                                                                            className={`${RequestTitle === "Request in Queue" ? "spin-image" : ""} cal-view-refresh-btn`}
                                                                            alt="Refresh"
                                                                            onClick={(e) => {
                                                                                if (RequestTitle === "Request in Queue") {
                                                                                    e.preventDefault()
                                                                                } else {
                                                                                    fnRequestForOnDemandRateShop(DTDate)
                                                                                }
                                                                            }

                                                                            }
                                                                        />
                                                                        :
                                                                        <>
                                                                            {
                                                                                DTDate >= CurrentDateMinone && RateshopPara.Channel &&
                                                                                <img id={commonService.generateGlobalClickTrackerID("RMRateShop", "refresh-RequestTitle", "")}
                                                                                    src={RequestStatus}
                                                                                    title={RequestTitle}
                                                                                    className="cal-view-refresh-btn"
                                                                                    alt="Refresh"
                                                                                    onClick={(e) => fnRequestForOnDemandRateShop(DTDate)}
                                                                                />
                                                                            }
                                                                        </>
                                                                }
                                                            </>

                                                        )}
                                                    </>
                                            }

                                            {checkEvent?.length > 0 && (
                                                <img id={commonService.generateGlobalClickTrackerID("RMRateShop", "event-check-ticket", "")}
                                                    src={ticket}
                                                    alt="ticket"
                                                    onClick={() => {
                                                        selectedEventDateRef.current = DTDate;
                                                        eventListPropsRef.current = checkEvent;
                                                        setShowTicketModal(true);
                                                    }}
                                                />
                                            )}
                                            {checkReminder?.length > 0 && (
                                                <img id={commonService.generateGlobalClickTrackerID("RMRateShop", "alarm", "")}
                                                    src={alarm}
                                                    alt="alarm"
                                                    onClick={() => {
                                                        reminderListPropsRef.current = checkReminder;
                                                        isReminderRef.current = true;
                                                        setViewReminderModal(true);
                                                    }}
                                                />
                                            )}
                                        </div>

                                        {CalFirstDate?.getMonth() == calDate.getMonth() && (
                                            <img id={commonService.generateGlobalClickTrackerID("RMRateShop", "dateverticalthreedot", "")}
                                                src={dateVerticalThreeDot}
                                                onClick={(e) => {
                                                    if (
                                                        moment(clikedDateRef.current).format(
                                                            "YYYY-MM-DD"
                                                        ) === moment(DTDate).format("YYYY-MM-DD")
                                                    ) {
                                                        isRateShopSoldOutRef.current = checkSoldOut;
                                                        clikedDateRef.current = "";
                                                        closeSingleDate();
                                                    } else {
                                                        isRateShopSoldOutRef.current = checkSoldOut;
                                                        clikedDateRef.current = DTDate;
                                                        handleFilterBtnClick(e);
                                                    }
                                                }}
                                                alt="dateVerticalThreeDot"
                                            />
                                        )}
                                    </div>
                                    {CalFirstDate?.getMonth() === calDate.getMonth() && (
                                        <>
                                            <div id={commonService.generateGlobalClickTrackerID("RMRateShop", "rate", "")}
                                                DTDate={DTDate}
                                                className="revenueOnSameDate"
                                                onClick={() => {
                                                    setClickedDate(DTDate);
                                                    setToolsSummaryModal(true);
                                                }}
                                                title="Rate"
                                            >
                                                {rateShopList[CalFirstDate.getDate()]?.isSelf?.rate
                                                    ? commonService.formateAmount(
                                                        Math.round(
                                                            rateShopList[CalFirstDate.getDate()]?.isSelf?.rate
                                                        )
                                                    )
                                                    : commonService.formateAmount(0)}
                                            </div>
                                            {
                                                <div className="min-max-avg-change-data">
                                                    {
                                                        <div title={diffType.toUpperCase() + ". Rate"}>
                                                            {diffType === "avg" && commonService.formateAmount(Math.round(rateShopList[CalFirstDate.getDate()]?.total / rateShopList[CalFirstDate.getDate()]?.lengthForAvg))}
                                                            {diffType === "max" && commonService.formateAmount(rateShopList[CalFirstDate.getDate()]?.max)}
                                                            {diffType === "min" && commonService.formateAmount(rateShopList[CalFirstDate.getDate()]?.min)}
                                                        </div>
                                                    }

                                                    {
                                                        rateShopList[CalFirstDate.getDate()]?.isSelf?.RateDifference && parseInt(rateShopList[CalFirstDate.getDate()]?.isSelf?.RateDifference) !== 0 ?
                                                            <div
                                                                DTDate={DTDate}
                                                                className={`${parseInt(rateShopList[CalFirstDate.getDate()]?.isSelf?.RateDifference) < 0 ? "redText" : "darkgreenText"}`}
                                                                title="Change"
                                                            >
                                                                {commonService.formateAmount(parseInt(rateShopList[CalFirstDate.getDate()]?.isSelf?.RateDifference))}
                                                            </div>
                                                            :
                                                            <div></div>
                                                    }
                                                </div>
                                            }
                                        </>
                                    )}
                                    <div className="percentage-data">
                                        {
                                            (findOccPercenatge?.[0]?.OnTheBook && Math.round(findOccPercenatge?.[0]?.OnTheBook) > 0) ?
                                                <h6
                                                    title="OTB"
                                                    style={{
                                                        color: "#008000",
                                                        border: "1px solid #008000",
                                                        width: "35px",
                                                        height: "25px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginBottom: "0",
                                                    }}
                                                >
                                                    {findOccPercenatge?.[0]?.OnTheBook
                                                        ? `${findOccPercenatge?.[0]?.OnTheBook}`
                                                        : ""}
                                                </h6>
                                                :
                                                <h6> </h6>
                                        }
                                        {findOccPercenatge?.[0]?.ForecastRoom && (
                                            <h6
                                                title="Forecast"
                                                style={{
                                                    color: "#0000FF",
                                                    border: "1px solid #0000FF",
                                                    width: "35px",
                                                    height: "25px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    marginBottom: "0",
                                                }}
                                            >
                                                {findOccPercenatge?.[0]?.ForecastRoom
                                                    ? `${findOccPercenatge?.[0]?.ForecastRoom}`
                                                    : ""}
                                            </h6>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </td>
                );
                CalFirstDate = new Date(
                    CalFirstDate.setDate(CalFirstDate.getDate() + 1)
                );
            }
            calendar.push(<tr key={i}>{row}</tr>);
        }

        return calendar;
    };

    const getRateShopSoldOutList = async () => {
        if (api === 0) return;
        if (!propertyId) return;
        let soldOutListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.RATESHOP_SOLDOUT.GET_LIST,
                body: {
                    propertyid: propertyId,
                    year: new Date(dateRange.start).getFullYear(),
                    month: new Date(dateRange.start).getMonth() + 1,
                },
            },
            false
        );

        let response = apiResponse(false, soldOutListResponse);

        if (response?.isValidate) {
            setSoldOutList(response?.data?.data);
        }

        if (!response?.isValidate) {
            setSoldOutList(null);
        }
    };

    const soldOut = async () => {
        let soldOutResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.RATESHOP_SOLDOUT.SAVE,
                body: {
                    propertyid: propertyId,
                    soldoutdate: commonService.getDateInDBFormat(clikedDateRef.current),
                    details: "",
                    propertyname: "",
                },
            },
            true
        );

        let response = apiResponse(false, soldOutResponse);

        if (response?.isValidate) {
            closeSingleDate();
            getRateShopSoldOutList();
        }

        if (!response?.isValidate) {
            closeSingleDate();
        }
    };

    const unsoldOut = async (soldOutData) => {
        let unsoldRateShopResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.RATESHOP_SOLDOUT.DELETE,
                body: {
                    id: soldOutData?.[0]?.rateshopsoldoutdetailsid,
                    // "date": "2023-11-21T09:04:42.057Z"
                },
            },
            false
        );

        let response = apiResponse(false, unsoldRateShopResponse);

        if (response?.isValidate) {
            closeSingleDate();
            getRateShopSoldOutList();
        }

        if (!response?.isValidate) {
            closeSingleDate();
        }
    };

    const handlePrevMonth = () => {
        setCurrentDate((cd) => {
            const cdv = new Date(cd);
            const currentDay = cdv.getDate();
            //const currentMonth = cdv.getMonth();
            //const currentYear = cdv.getFullYear();

            cdv.setMonth(cdv.getMonth() - 1);

            if (cdv.getDate() !== currentDay) {
                cdv.setDate(0);
            }

            return cdv;
        });
    };

    const handleNextMonth = () => {
        setCurrentDate((cd) => {
            const cdv = new Date(cd);
            const currentDay = cdv.getDate();
            cdv.setMonth(cdv.getMonth() + 1);

            if (cdv.getDate() !== currentDay) {
                cdv.setDate(0);
            }

            return cdv;
        });
    };



    const getCompetitorList = async () => {
        if (api === 0) return;
        if (!propertyCode || !propertyId) return;
        let competitorListResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.RATESHOP.COMPETITOR_LIST,
                body: {
                    propertyCode: propertyCode,
                    propertyid: propertyId,
                },
            },
            false
        );

        let response = apiResponse(false, competitorListResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let competitorNameList = {};
            let _AllChannels = [];
            let _Band = { label: "BRAND", value: "" };
            for (let i = 0; i < dataFromApi?.length; i++) {
                competitorNameList = {
                    ...competitorNameList,
                    [dataFromApi?.[i]?.competiterpropertyname]: true,
                };

                if (dataFromApi?.[i]?.allchanneljson) {
                    let chalnnel = JSON.parse(dataFromApi?.[i]?.allchanneljson);
                    if (chalnnel && chalnnel.length > 0) {
                        for (let c = 0; c < chalnnel.length; c++) {
                            if (chalnnel[c].text && chalnnel[c].id) {
                                if (chalnnel[c].text.toUpperCase() !== "BRAND") {
                                    _AllChannels.push({ label: chalnnel[c].text, value: chalnnel[c].id });
                                    _AllChannels = [...new Map(_AllChannels.map(item => [item.value, item])).values()];
                                }
                                else {
                                    _Band.value = _Band.value + "," + chalnnel[c].id;
                                    _Band.value = _Band.value.replace(/^,|,$/g, '');
                                }
                            }
                        }
                    }
                }
            }

            if (_Band.value) {
                _AllChannels.push(_Band);
            }

            setAllChannels(_AllChannels)
            setSelectedCompetitorList(competitorNameList);
            selectedCompetitorListRef.current = competitorNameList;
            setCompetitorList(response?.data?.data);
        }

        if (!response?.isValidate) {
            selectedCompetitorListRef.current = {};
            setSelectedCompetitorList(null);
            setCompetitorList(null);
        }
    };

    const getReminderList = async () => {
        if (api === 0) return;
        if (!propertyId) return;
        let reminderListResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.REMINDER.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: propertyId,
                    startdate: commonService.getDateInDBFormat(dateRange?.start),
                    enddate: commonService.getDateInDBFormat(dateRange?.end),
                    remindername: "",
                    remindertypeterm: "",
                },
            },
            false
        );

        let reminderResponse = apiResponse(false, reminderListResponse);

        if (reminderResponse?.isValidate) {
            reminderListRef.current = reminderResponse?.data?.data || [];
            setReminderListData(reminderResponse?.data?.data || []);
        }
    };

    const getEventList = async () => {
        if (api === 0) return;
        if (!propertyId) return;
        let eventList = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(propertyId),
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: ``,
                },
            },
            false
        );

        let eventListResponse = apiResponse(false, eventList);

        if (eventListResponse?.isValidate) {
            let eventListArr = [];

            eventListResponse?.data?.data?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: item?.startdate,
                        endDate: item?.enddate,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventListArr.push(singleEventObj);
                }
                catch (err) { }
            });
            eventListRef.current = eventListArr;
            setEventListData(eventListArr);
        }

        if (!eventListResponse?.isValidate) {
            eventListRef.current = [];
            setEventListData([]);
        }
    };


    const [requestList, setRequestList] = useState([]);

    const getRequestList = async () => {
        if (api === 0) return;
        if (!propertyId) return;
        let response = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Notification +
                    API_URL.THIRD_PARTY_API_REQUEST.GET_ONDEMAND_LIST,
                body: {
                    propertyid: parseInt(propertyId),
                    startrequestfordate: moment(dateRange?.start).format("YYYY-MM-DD"),
                    endrequestfordate: moment(dateRange?.end).format("YYYY-MM-DD"),
                },
            },
            false
        );

        let res = apiResponse(false, response);
        if (res?.isValidate) {
            setRequestList(res?.data?.data || []);
        }
        if (!res?.isValidate) {
            setRequestList([]);
        }
    };

    const [RateshopParaValidation, setRateshopParaValidation] = useState({
        Channel: "",
        Night: "",
        Guest: ""
    });
    const [loading, setLoading] = useState(false);

    const [OnDemandDateLoading, setOnDemandDateLoading] = useState([]);

    // ---------------------------------------------------------------------
    // Calendar performance indexes
    // These preserve the existing data/behaviour but avoid scanning the same
    // arrays for every one of the 42 calendar cells on every render.
    // ---------------------------------------------------------------------
    const calendarDateKey = (value) => {
        if (!value) return "";
        return moment(value).format("YYYY-MM-DD");
    };

    const buildRangeIndex = (items, startField, endField) => {
        const index = {};
        (items || []).forEach((item) => {
            const start = moment(item?.[startField]);
            const end = moment(item?.[endField]);
            if (!start.isValid() || !end.isValid()) return;

            const cursor = start.clone().startOf("day");
            const last = end.clone().startOf("day");
            // Prevent malformed API data from creating an unbounded loop.
            if (last.diff(cursor, "days") > 366) return;

            while (cursor.isSameOrBefore(last, "day")) {
                const key = cursor.format("YYYY-MM-DD");
                if (!index[key]) index[key] = [];
                index[key].push(item);
                cursor.add(1, "day");
            }
        });
        return index;
    };

    const eventsByDate = useMemo(
        () => buildRangeIndex(eventListData, "startDate", "endDate"),
        [eventListData]
    );

    const remindersByDate = useMemo(
        () => buildRangeIndex(reminderListData, "startdate", "enddate"),
        [reminderListData]
    );

    const soldOutByDate = useMemo(() => {
        const index = {};
        (soldOutList || []).forEach((item) => {
            const key = calendarDateKey(item?.soldoutdate);
            if (!key) return;
            if (!index[key]) index[key] = [];
            index[key].push(item);
        });
        return index;
    }, [soldOutList]);

    const forecastByDate = useMemo(() => {
        const index = {};
        (rateShopForecastData || []).forEach((item) => {
            const key = calendarDateKey(item?.Date);
            if (!key) return;
            if (!index[key]) index[key] = [];
            index[key].push(item);
        });
        return index;
    }, [rateShopForecastData]);

    const requestByTitle = useMemo(() => {
        const index = {};
        (requestList || []).forEach((item) => {
            const key = String(item?.requesttitle || "").toUpperCase();
            if (key) index[key] = item;
        });
        return index;
    }, [requestList]);

    const onDemandLoadingByDate = useMemo(() => {
        const index = {};
        (OnDemandDateLoading || []).forEach((item) => {
            const key = item?.date;
            if (!key) return;
            if (!index[key]) index[key] = [];
            index[key].push(item);
        });
        return index;
    }, [OnDemandDateLoading]);

    const getComparisonColor = (percentage, border = false) => {
        let result = "";
        (colorComparisonData || []).forEach((item) => {
            if (percentage >= item?.minper && percentage <= item?.maxper) {
                result = border ? `6px solid ${item?.indicatorcolor}` : item?.indicatorcolor;
            }
        });
        return result;
    };

    const fnRequestForOnDemandRateShop = async (date) => {
        if (date) {
            if (date && RateshopPara.Channel && RateshopPara.Night && RateshopPara.Guest) {

                let _OnDemandDateLoading = structuredClone(OnDemandDateLoading);
                _OnDemandDateLoading.push({ date: commonService.getDateInDBFormat(date) })
                setOnDemandDateLoading(_OnDemandDateLoading);


                setRateshopParaValidation({
                    Channel: "",
                    Night: "",
                    Guest: ""
                });

                let sources = [];
                RateshopPara.Channel.split(",").map((c) => { if (c) { sources.push(parseInt(c)) } });
                let hotelcode = 0;
                let competitorhotelcodes = [];
                competitorList.map((compset) => {
                    if (compset.isself) {
                        hotelcode = compset.competiterpropertycode ? parseInt(compset.competiterpropertycode) : 0
                    }
                    else {
                        competitorhotelcodes.push(compset.competiterpropertycode ? parseInt(compset.competiterpropertycode) : 0)
                    }
                })


                let body = {
                    hotelname: propertyDetailFromRTK?.propertyname,
                    propertycode: propertyCode,
                    propertyid: propertyId,
                    rateshopname: commonService.getConvertDateInTimeZone(date) + " Night : " + parseInt(RateshopPara.Night) + " Guest : " + parseInt(RateshopPara.Guest) + " Channel : " + RateshopPara.ChannelName,
                    los: parseInt(RateshopPara.Night),
                    occupancy: parseInt(RateshopPara.Guest),
                    currency: "",
                    horizon: 0,
                    hotelcode: 0,
                    hotelcodes: [0],
                    compsets: [{ hotelcode: hotelcode, competitorhotelcodes: competitorhotelcodes }],
                    sources: sources,
                    startdate: commonService.getDateInDBFormat(date),
                    fetchtype: 0,
                    horizonexpression: "",
                    pos: 0,
                    horizonrange: commonService.getDateInRatemetricsHorizonRangeFormat(date) + "-" + commonService.getDateInRatemetricsHorizonRangeFormat(date)

                }
                // setLoading(true);

                let addResponse = await apiCall(
                    {
                        method: "POST",
                        url: API_URL.BASE_API_URL.RevenueManagement + API_URL.REVENUE_RATE_SHOP_CONFIG.RATE_METRICS_CREATE_ONDEMAND_RATE_SHOP_REQUEST,
                        body: body,
                    },
                    false
                );

                let response = apiResponse(true, addResponse, setLoading);

                /*if (response?.isValidate) {*/
                getRequestList();

                let _OnDemandDateLoadingRemove = structuredClone(OnDemandDateLoading);
                _OnDemandDateLoadingRemove = _OnDemandDateLoadingRemove.filter(x => x.date !== commonService.getDateInDBFormat(date));
                setOnDemandDateLoading(_OnDemandDateLoadingRemove);
                //}

                setLoading(false);
            }
            else {
                let Channel = "";
                let Night = "";
                let Guest = "";

                if (RateshopPara.Channel === "") {
                    Channel = "invalid"
                }

                if (RateshopPara.Night === "") {
                    Night = "invalid"
                }

                if (RateshopPara.Guest === "") {
                    Guest = "invalid"
                }
                setRateshopParaValidation({
                    Channel: Channel,
                    Night: Night,
                    Guest: Guest
                })
            }
        }
    };

    const [channel_term, setchannel_term] = useState("");

    const getRateShopConfigByPropertyId = async () => {
        if (api === 0) return;
        if (!propertyId) return;
        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: parseInt(propertyId)
                },
            },
            false
        );

        let response = apiResponse(false, byPropertyIdResponse);

        if (response?.isValidate) {
            setchannel_term(response?.data?.data?.channel_term)
            setRateshopPara((prev) => {
                const next = {
                    ...prev,
                    Night: parseInt(response?.data?.data?.totallos),
                    Guest: parseInt(response?.data?.data?.totalguest),
                    RateShopConfigType: parseInt(response?.data?.data?.rateshopconfigtype),
                    Channel: response?.data?.data?.channel_term || "",
                };

                if (
                    prev.Night === next.Night &&
                    prev.Guest === next.Guest &&
                    prev.RateShopConfigType === next.RateShopConfigType &&
                    prev.Channel === next.Channel
                ) {
                    return prev;
                }

                return next;
            });
        }

    };

    useEffect(() => {
        if (api === 0) return;
        if (AllChannels && AllChannels.length > 0 && RateshopPara?.Channel) {
            let matchedChannel = AllChannels.find(
                (item) => String(item.value) === String(RateshopPara.Channel) ||
                    String(item.label).toLowerCase() === String(RateshopPara.Channel).toLowerCase()
            );
            if (matchedChannel && (RateshopPara.ChannelName !== matchedChannel.label || RateshopPara.Channel !== matchedChannel.value)) {
                setRateshopPara((prev) => ({
                    ...prev,
                    Channel: matchedChannel.value ? matchedChannel.value.toString() : "",
                    ChannelName: matchedChannel.label,
                }));
            }
            else {
                setRateshopPara((prev) => ({
                    ...prev,
                    Channel: "",
                    ChannelName: "",
                }));
            }
        }
    }, [AllChannels, RateshopPara?.Channel, RateshopPara?.ChannelName]);


    useEffect(() => {
        if (api === 0) return;
        if (propertyCode && propertyId) {
            getEventList();
            getRequestList();
        }
    }, [dateRange]);

    const getRateShopList = async (forceRefresh = false) => {
        if (api === 0) return;
        if (!propertyCode || !propertyId) return;

        //await getEventList();
        //await getRequestList();

        if (asOfDateFromRTK) {
            setLoading(true);
            let CompareDate = new Date(asOfDateFromRTK);
            CompareDate = CompareDate.setDate(CompareDate.getDate() - Compare)

            const rateShopRequestBody = {
                propertycode: propertyCode,
                startdate: moment(dateRange?.start).format("YYYY-MM-DD"),
                enddate: moment(dateRange?.end).format("YYYY-MM-DD"),
                comparedateformatted: CompareDate ? commonService.getDateInDBFormat(CompareDate) : null,
                compsettype: RateshopPara.CompSetType ? RateshopPara.CompSetType : null,
                channel: RateshopPara.ChannelName && RateshopPara.ChannelName.toUpperCase() !== "ANY CHANNELS" ? RateshopPara.ChannelName : null,
                night: RateshopPara.Night ? parseInt(RateshopPara.Night) : 1,
                guests: RateshopPara.Guest ? parseInt(RateshopPara.Guest) : 2,
                asofdate: asOfDateFromRTK ? asOfDateFromRTK : "",
                roomtype: RateshopPara.RoomType ? parseInt(RateshopPara.RoomType) : null,
                propertyid: propertyId,
            };

            const requestKey = JSON.stringify({
                ...rateShopRequestBody,
                _refreshToken: callApi ? 1 : 0,
            });
            if (!forceRefresh && rateShopRequestTrackerRef.current.key === requestKey) {
                return;
            }
            rateShopRequestTrackerRef.current = { key: requestKey, inFlight: true };

            let rateShopListResponse = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.RATESHOP.NEW_RATESHOP_LIST,
                    body: rateShopRequestBody,
                },
                false
            );

            let response = apiResponse(false, rateShopListResponse);

            if (response?.isValidate) {
                let dataFromApi = response?.data?.data?.RateShop;
                rateShopListRef.current = dataFromApi;
                let groupingJson = {};
                for (let i = 0; i < dataFromApi?.length; i++) {
                    let keyName =
                        dataFromApi[i]?.IsSelf === true
                            ? "isSelf"
                            : dataFromApi[i]?.competiterpropertyname;
                    if (
                        groupingJson.hasOwnProperty(
                            moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                            // new Date(dataFromApi[i]?.CheckInDate).getDate()
                        )
                    ) {
                        groupingJson[moment(dataFromApi[i]?.CheckInDate).toDate().getDate()] =
                        {
                            ...groupingJson[
                            moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                            ],
                            /* FOR ONLY COMPETITOR MIN VALUE */
                            lengthForAvg:
                                dataFromApi[i]?.IsSelf === true
                                    ? groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.lengthForAvg
                                    : parseInt(dataFromApi[i]?.Rate) > 0
                                        ? groupingJson[
                                            moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                        ]?.lengthForAvg + 1
                                        : groupingJson[
                                            moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                        ]?.lengthForAvg,
                            total:
                                dataFromApi[i]?.IsSelf === true
                                    ? groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.total
                                    : groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.total
                                        ? groupingJson[
                                            moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                        ]?.total + parseInt(dataFromApi[i]?.Rate)
                                        : parseInt(dataFromApi[i]?.Rate),
                            max:
                                dataFromApi[i]?.IsSelf === true
                                    ? groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.max
                                    : groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.max
                                        ? groupingJson[
                                            moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                        ]?.max < parseInt(dataFromApi[i]?.Rate)
                                            ? parseInt(dataFromApi[i]?.Rate)
                                            : groupingJson[
                                                moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                            ]?.max
                                        : parseInt(dataFromApi[i]?.Rate),
                            min:
                                dataFromApi[i]?.IsSelf === true
                                    ? groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.min
                                    : groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.min
                                        ? groupingJson[
                                            moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                        ]?.min > parseInt(dataFromApi[i]?.Rate) &&
                                            parseInt(dataFromApi[i]?.Rate) > 0
                                            ? parseInt(dataFromApi[i]?.Rate)
                                            : groupingJson[
                                                moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                            ]?.min
                                        : parseInt(dataFromApi[i]?.Rate) > 0
                                            ? parseInt(dataFromApi[i]?.Rate)
                                            : "",
                            [keyName]: {
                                competitorName: dataFromApi[i]?.competiterpropertyname,
                                competitorCode: dataFromApi[i]?.CompetitorID,
                                rateShopScheduleId: dataFromApi[i]?.RateShopScheduleID,
                                propertyCode: dataFromApi[i]?.PropertyCode,
                                checkInDate: dataFromApi[i]?.CheckInDate,
                                rate: dataFromApi[i]?.Rate,
                                discount: dataFromApi[i]?.Discount,
                                memberDiscount: dataFromApi[i]?.MemberDiscount,
                                channel: dataFromApi[i]?.Channel,
                                guests: dataFromApi[i]?.Guests,
                                los: dataFromApi[i]?.LOS,
                                EventIDs: dataFromApi[i]?.EventIDs,
                                roomType: dataFromApi[i]?.RoomType,
                                isSelf: dataFromApi[i]?.IsSelf,
                                isLowestRate: dataFromApi[i]?.IsLowestRate,
                                isBarRate: dataFromApi[i]?.IsBarRate,
                                RateDifference: dataFromApi[i]?.RateDifference,

                            },
                        };
                    } else {
                        groupingJson = {
                            ...groupingJson,
                            [moment(dataFromApi[i]?.CheckInDate).toDate().getDate()]: {
                                /* FOR ONLY COMPETITOR MIN VALUE */
                                lengthForAvg:
                                    dataFromApi[i]?.IsSelf === true
                                        ? 0
                                        : parseInt(dataFromApi[i]?.Rate) > 0
                                            ? 1
                                            : 0,
                                total:
                                    dataFromApi[i]?.IsSelf === true
                                        ? ""
                                        : parseInt(dataFromApi[i]?.Rate) > 0
                                            ? parseInt(dataFromApi[i]?.Rate)
                                            : "",
                                max:
                                    dataFromApi[i]?.IsSelf === true
                                        ? ""
                                        : parseInt(dataFromApi[i]?.Rate) > 0
                                            ? parseInt(dataFromApi[i]?.Rate)
                                            : "",
                                min:
                                    dataFromApi[i]?.IsSelf === true
                                        ? ""
                                        : parseInt(dataFromApi[i]?.Rate) > 0
                                            ? parseInt(dataFromApi[i]?.Rate)
                                            : "",
                                [keyName]: {
                                    competitorName: dataFromApi[i]?.competiterpropertyname,
                                    competitorCode: dataFromApi[i]?.CompetitorID,
                                    rateShopScheduleId: dataFromApi[i]?.RateShopScheduleID,
                                    propertyCode: dataFromApi[i]?.PropertyCode,
                                    checkInDate: dataFromApi[i]?.CheckInDate,
                                    rate: dataFromApi[i]?.Rate,
                                    discount: dataFromApi[i]?.Discount,
                                    memberDiscount: dataFromApi[i]?.MemberDiscount,
                                    channel: dataFromApi[i]?.Channel,
                                    guests: dataFromApi[i]?.Guests,
                                    los: dataFromApi[i]?.LOS,
                                    EventIDs: dataFromApi[i]?.EventIDs,
                                    roomType: dataFromApi[i]?.RoomType,
                                    isSelf: dataFromApi[i]?.IsSelf,
                                    isLowestRate: dataFromApi[i]?.IsLowestRate,
                                    isBarRate: dataFromApi[i]?.IsBarRate,
                                    RateDifference: dataFromApi[i]?.RateDifference,

                                },
                            },
                        };
                    }
                }
                setRateShopForecastData(response?.data?.data?.Forcast_data);
                setRateShopList(groupingJson);
                setLoading(false);
            }

            if (!response?.isValidate) {
                setRateShopList({
                    1: { isSelf: { Rate: 0 } },
                    2: { isSelf: { Rate: 0 } },
                    3: { isSelf: { Rate: 0 } },
                    4: { isSelf: { Rate: 0 } },
                    5: { isSelf: { Rate: 0 } },
                    6: { isSelf: { Rate: 0 } },
                    7: { isSelf: { Rate: 0 } },
                    8: { isSelf: { Rate: 0 } },
                    9: { isSelf: { Rate: 0 } },
                    10: { isSelf: { Rate: 0 } },
                    11: { isSelf: { Rate: 0 } },
                    12: { isSelf: { Rate: 0 } },
                    13: { isSelf: { Rate: 0 } },
                    14: { isSelf: { Rate: 0 } },
                    15: { isSelf: { Rate: 0 } },
                    16: { isSelf: { Rate: 0 } },
                    17: { isSelf: { Rate: 0 } },
                    18: { isSelf: { Rate: 0 } },
                    19: { isSelf: { Rate: 0 } },
                    20: { isSelf: { Rate: 0 } },
                    21: { isSelf: { Rate: 0 } },
                    22: { isSelf: { Rate: 0 } },
                    23: { isSelf: { Rate: 0 } },
                    24: { isSelf: { Rate: 0 } },
                    25: { isSelf: { Rate: 0 } },
                    26: { isSelf: { Rate: 0 } },
                    27: { isSelf: { Rate: 0 } },
                    28: { isSelf: { Rate: 0 } },
                    29: { isSelf: { Rate: 0 } },
                    30: { isSelf: { Rate: 0 } },
                    31: { isSelf: { Rate: 0 } },
                });
                setRateShopForecastData(null);
                rateShopListRef.current = null;
                rateShopRequestTrackerRef.current = { key: "", inFlight: false };
                setLoading(false);
                return;
            }

            rateShopRequestTrackerRef.current = { key: requestKey, inFlight: false };
        }
    };

    const calculateCalDetail = () => {
        let dataFromApi = rateShopListRef.current;
        let groupingJson = {};
        for (let i = 0; i < dataFromApi?.length; i++) {
            let keyName =
                dataFromApi[i]?.IsSelf === true
                    ? "isSelf"
                    : dataFromApi[i]?.competiterpropertyname;
            if (
                groupingJson.hasOwnProperty(
                    new Date(dataFromApi[i]?.CheckInDate).getDate()
                )
            ) {
                if (
                    selectedCompetitorListRef.current?.[
                    dataFromApi[i]?.competiterpropertyname
                    ]
                ) {
                    groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()] = {
                        ...groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()],
                        // lengthForAvg:
                        //   dataFromApi[i]?.IsSelf === true
                        //     ? groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()]
                        //         ?.lengthForAvg
                        //     : parseInt(dataFromApi[i]?.Rate) > 0
                        //     ? groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()]
                        //         ?.lengthForAvg + 1
                        //     : groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()]
                        //         ?.lengthForAvg,
                        // total:
                        //   groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()]
                        //     ?.total + parseInt(dataFromApi[i]?.Rate),
                        // max:
                        //   groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()]
                        //     ?.max < parseInt(dataFromApi[i]?.Rate)
                        //     ? parseInt(dataFromApi[i]?.Rate)
                        //     : groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()]
                        //         ?.max,
                        // min:
                        //   groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()]
                        //     ?.min > parseInt(dataFromApi[i]?.Rate)
                        //     ? parseInt(dataFromApi[i]?.Rate)
                        //     : groupingJson[new Date(dataFromApi[i]?.CheckInDate).getDate()]
                        //         ?.min,

                        lengthForAvg:
                            dataFromApi[i]?.IsSelf === true
                                ? groupingJson[
                                    moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                ]?.lengthForAvg
                                : parseInt(dataFromApi[i]?.Rate) > 0
                                    ? groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.lengthForAvg + 1
                                    : groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.lengthForAvg,
                        total:
                            dataFromApi[i]?.IsSelf === true
                                ? groupingJson[
                                    moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                ]?.total
                                : groupingJson[
                                    moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                ]?.total
                                    ? groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.total + parseInt(dataFromApi[i]?.Rate)
                                    : parseInt(dataFromApi[i]?.Rate),
                        max:
                            dataFromApi[i]?.IsSelf === true
                                ? groupingJson[
                                    moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                ]?.max
                                : groupingJson[
                                    moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                ]?.max
                                    ? groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.max < parseInt(dataFromApi[i]?.Rate)
                                        ? parseInt(dataFromApi[i]?.Rate)
                                        : groupingJson[
                                            moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                        ]?.max
                                    : parseInt(dataFromApi[i]?.Rate),
                        min:
                            dataFromApi[i]?.IsSelf === true
                                ? groupingJson[
                                    moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                ]?.min
                                : groupingJson[
                                    moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                ]?.min
                                    ? groupingJson[
                                        moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                    ]?.min > parseInt(dataFromApi[i]?.Rate) &&
                                        parseInt(dataFromApi[i]?.Rate) > 0
                                        ? parseInt(dataFromApi[i]?.Rate)
                                        : groupingJson[
                                            moment(dataFromApi[i]?.CheckInDate).toDate().getDate()
                                        ]?.min
                                    : parseInt(dataFromApi[i]?.Rate) > 0
                                        ? parseInt(dataFromApi[i]?.Rate)
                                        : "",
                        [keyName]: {
                            competitorName: dataFromApi[i]?.competiterpropertyname,
                            competitorCode: dataFromApi[i]?.CompetitorID,
                            rateShopScheduleId: dataFromApi[i]?.RateShopScheduleID,
                            propertyCode: dataFromApi[i]?.PropertyCode,
                            checkInDate: dataFromApi[i]?.CheckInDate,
                            rate: dataFromApi[i]?.Rate,
                            discount: dataFromApi[i]?.Discount,
                            memberDiscount: dataFromApi[i]?.MemberDiscount,
                            channel: dataFromApi[i]?.Channel,
                            guests: dataFromApi[i]?.Guests,
                            los: dataFromApi[i]?.LOS,
                            EventIDs: dataFromApi[i]?.EventIDs,
                            roomType: dataFromApi[i]?.RoomType,
                            isSelf: dataFromApi[i]?.IsSelf,
                            isLowestRate: dataFromApi[i]?.IsLowestRate,
                            isBarRate: dataFromApi[i]?.IsBarRate,
                            RateDifference: dataFromApi[i]?.RateDifference,
                        },
                    };
                }
            } else {
                if (
                    selectedCompetitorListRef.current?.[
                    dataFromApi[i]?.competiterpropertyname
                    ]
                ) {
                    groupingJson = {
                        ...groupingJson,
                        [new Date(dataFromApi[i]?.CheckInDate).getDate()]: {
                            // lengthForAvg:
                            //   dataFromApi[i]?.IsSelf === true
                            //     ? 0
                            //     : parseInt(dataFromApi[i]?.Rate) > 0
                            //     ? 1
                            //     : 0,
                            // total: parseInt(dataFromApi[i]?.Rate),
                            // max: parseInt(dataFromApi[i]?.Rate),
                            // min: parseInt(dataFromApi[i]?.Rate),

                            lengthForAvg:
                                dataFromApi[i]?.IsSelf === true
                                    ? 0
                                    : parseInt(dataFromApi[i]?.Rate) > 0
                                        ? 1
                                        : 0,
                            total:
                                dataFromApi[i]?.IsSelf === true
                                    ? ""
                                    : parseInt(dataFromApi[i]?.Rate) > 0
                                        ? parseInt(dataFromApi[i]?.Rate)
                                        : "",
                            max:
                                dataFromApi[i]?.IsSelf === true
                                    ? ""
                                    : parseInt(dataFromApi[i]?.Rate) > 0
                                        ? parseInt(dataFromApi[i]?.Rate)
                                        : "",
                            min:
                                dataFromApi[i]?.IsSelf === true
                                    ? ""
                                    : parseInt(dataFromApi[i]?.Rate) > 0
                                        ? parseInt(dataFromApi[i]?.Rate)
                                        : "",
                            [keyName]: {
                                competitorName: dataFromApi[i]?.competiterpropertyname,
                                competitorCode: dataFromApi[i]?.CompetitorID,
                                rateShopScheduleId: dataFromApi[i]?.RateShopScheduleID,
                                propertyCode: dataFromApi[i]?.PropertyCode,
                                checkInDate: dataFromApi[i]?.CheckInDate,
                                rate: dataFromApi[i]?.Rate,
                                discount: dataFromApi[i]?.Discount,
                                memberDiscount: dataFromApi[i]?.MemberDiscount,
                                channel: dataFromApi[i]?.Channel,
                                guests: dataFromApi[i]?.Guests,
                                los: dataFromApi[i]?.LOS,
                                EventIDs: dataFromApi[i]?.EventIDs,
                                roomType: dataFromApi[i]?.RoomType,
                                isSelf: dataFromApi[i]?.IsSelf,
                                isLowestRate: dataFromApi[i]?.IsLowestRate,
                                isBarRate: dataFromApi[i]?.IsBarRate,
                                RateDifference: dataFromApi[i]?.RateDifference,
                            },
                        },
                    };
                }
            }
        }
        setRateShopList(groupingJson);
    };

    const getColorComparisonData = async () => {
        if (api === 0) return;
        if (!propertyId) return;
        let colorComparisonResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_COMPARISON.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    title: "",
                    propertyid: propertyId,
                },
            },
            false
        );

        let response = apiResponse(false, colorComparisonResponse);

        if (response?.isValidate) {
            let data = response?.data?.data?.reverse();
            setColorComparisonData(data);
        }

        if (!response?.isValidate) {
            setColorComparisonData(null);
        }
    };

    useEffect(() => {
        if (api === 0) return;
        if (propertyCode && propertyId) {
            getRateShopConfigByPropertyId();
            getCompetitorList();
            getColorComparisonData();
        }
    }, [propertyCode, propertyId, api]);

    useEffect(() => {
        if (api === 0) return;
        if (propertyCode && propertyId) {
            getReminderList();
            getRateShopSoldOutList();
        }
    }, [dateRange, propertyCode, propertyId, api, callApi]);

    useEffect(() => {
        if (api === 0) return;
        if (propertyCode && propertyId) {
            getRateShopList();
        }
    }, [dateRange, propertyCode, propertyId, api, callApi, asOfDateFromRTK, Compare, RateshopPara.CompSetType, RateshopPara.ChannelName, RateshopPara.Night, RateshopPara.Guest, RateshopPara.RoomType]);

    const userDetail = commonService.getLoginUserData();
    useEffect(() => {
        if (api === 0) return;
        if (userDetail != null && userDetail.userid !== 0) {
            const connect = new HubConnectionBuilder()
                .withUrl(API_URL.BASE_API_URL.LogAndMessage, { withCredentials: false })
                .withAutomaticReconnect()
                .build();
            connect
                .start()
                .then(() => {
                    connect.send("connect", userDetail.userid);
                    connect.on("getnotification", (data) => {
                        if (
                            document.querySelectorAll('[data_details="' + data.details + '"]')
                                .length === 0
                        ) {

                            if (data.associationtype === "On Demand Rateshop") {
                                toast.success(<>
                                    <div className="card-title h6" data_details={data.details}>
                                        <b>{data.title}</b>
                                    </div>
                                    <p className="card-text pt-2">{data.details}</p>
                                </>, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                    pauseOnFocusLoss: false,
                                });

                                if (propertyCode && propertyId) {
                                    getRequestList();
                                    getRateShopList(true);
                                }
                            }
                        }
                    });
                })
                .catch((error) => { });
        }
    }, []);



    return (
        <div className="RMRateShopMain">
            {propertyCode ? (
                <Container fluid>
                    <Row>
                        <Col xl={12}>
                            <div className="ProspectDashboardTitleWraper  d-flex justify-content-between align-items-center">
                                <h2>
                                    Dashboard-{" "}
                                    <span className="tab-title-main">
                                        Revenue Management - Tools - Rate Shop
                                    </span>
                                </h2>
                                <div className="generalTermSetup-heading-btns">
                                    <div className="from-groups no-border-break diffBgSelect">
                                        <Form.Select id={commonService.generateGlobalClickTrackerID("RMRateShop", "Compare-form-select-onchange", "")}
                                            aria-label="Select Compare"
                                            value={Compare}
                                            onChange={(e) => setCompare(parseInt(e.target.value))}
                                        >
                                            <option value="0">No comparison</option>
                                            <option value="1">vs. Yesterday</option>
                                            <option value="3">vs. 3 days ago</option>
                                            <option value="7">vs. 7 days ago</option>
                                            <option value="14">vs. 14 days ago</option>
                                            <option value="364">vs. SWLY</option>
                                        </Form.Select>
                                    </div>
                                    <div className="from-groups no-border-break diffBgSelect">
                                        <Form.Select id={commonService.generateGlobalClickTrackerID("RMRateShop", "diffType-form-select-onchange", "")}
                                            aria-label="Default select example"
                                            value={diffType}
                                            onChange={(e) => setDiffType(e.target.value)}
                                        >
                                            <option value="avg">Average</option>
                                            <option value="max">Max</option>
                                            <option value="min">Min</option>
                                        </Form.Select>
                                    </div>
                                    {/*<Link id={commonService.generateGlobalClickTrackerID("RMRateShop", "rate-shop-link", "")} to="/revenue/rate-shop">*/}
                                    {/*    <div className="heading-menu-btns">*/}
                                    {/*        <img src={calendarIcon} alt="calendarIcon" />*/}
                                    {/*    </div>*/}
                                    {/*</Link>*/}
                                    <Link id={commonService.generateGlobalClickTrackerID("RMRateShop", "rate-shop-table-view-link", "")} to={api === 0 ? "" : "/revenue/rate-shop/rate-shop-table-view"}>
                                        <div className="heading-menu-btns">
                                            <img src={horizobtalBarIcon} alt="horizobtalBarIcon" />
                                        </div>
                                    </Link>
                                    <div id={commonService.generateGlobalClickTrackerID("RMRateShop", "Show-adr-graphIcon-onclick", "")}
                                        className="heading-menu-btns cursorPointer"
                                        onClick={() => {
                                            if (api === 0) return;
                                            setShowAdrChart(true);
                                        }}
                                    >
                                        <img src={graphIcon} alt="graphIcon" />
                                    </div>

                                    <div id={commonService.generateGlobalClickTrackerID("RMRateShop", "downloadIcon-onclick", "")}
                                        import={tblids.RateShopTable}
                                        className="heading-menu-btns cursorPointer"
                                        onClick={() => {
                                            if (api === 0) return;
                                            commonService.fnExportInCSV(
                                                tblids.RateShopTable,
                                                // "Account"
                                                `${propertyCode}-Rate Shop-${moment(new Date()).format(
                                                    "MMDDYYYY"
                                                )}`
                                            )
                                        }
                                        }
                                    >
                                        <img src={downloadIcon} alt="Download" />
                                    </div>

                                    <div id={commonService.generateGlobalClickTrackerID("RMRateShop", "infoIcon-onclick", "")}
                                        className="heading-menu-btns cursorPointer"
                                        onClick={() => {
                                            if (api === 0) return;
                                            setWidgetModal(true);
                                        }}
                                    >
                                        <img src={infoIcon} alt="graphIcon" />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <div className="generalTermSetup-heading-btns">
                            <div className=" no-border-break">
                                <Form.Select id={commonService.generateGlobalClickTrackerID("RMRateShop", "Channel-form-select-onchange", "")} className={`${RateshopParaValidation.Channel && "error-border-on-element"}`} aria-label="Select Channel" value={RateshopPara.Channel}
                                    onChange={(e) => {
                                        setRateshopPara({
                                            ...RateshopPara,
                                            Channel: e.target.value,
                                            ChannelName: e.target.options[e.target.selectedIndex].text
                                        });
                                    }}>
                                    <option value="">Any Channels</option>
                                    {AllChannels?.map((item, idx) => (
                                        <option key={idx} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div className="no-border-break">
                                <Form.Select id={commonService.generateGlobalClickTrackerID("RMRateShop", "Night-form-select-onchange", "")} className={`${RateshopParaValidation.Night && "error-border-on-element"}`} aria-label="Select Night" value={RateshopPara.Night}
                                    onChange={(e) => {
                                        setRateshopPara({
                                            ...RateshopPara,
                                            Night: e.target.value,
                                        });
                                    }}
                                >
                                    {noOfNightsList?.map((item, idx) => (
                                        <option key={idx} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </Form.Select>

                            </div>
                            <div className="no-border-break ">
                                <Form.Select id={commonService.generateGlobalClickTrackerID("RMRateShop", "Guest-form-select-onchange", "")} className={`${RateshopParaValidation.Guest && "error-border-on-element"}`} aria-label="Select Guests" value={RateshopPara.Guest}
                                    onChange={(e) => {
                                        setRateshopPara({
                                            ...RateshopPara,
                                            Guest: e.target.value,
                                        });
                                    }}
                                >
                                    {noOfGuestsList?.map((item, idx) => (
                                        <option key={idx} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div className="no-border-break ">
                                <Form.Select id={commonService.generateGlobalClickTrackerID("RMRateShop", "RoomType-form-select-onchange", "")} aria-label="Select Room Type" value={RateshopPara.RoomType}
                                    onChange={(e) => {
                                        setRateshopPara({
                                            ...RateshopPara,
                                            RoomType: e.target.value,
                                        });
                                    }}
                                >
                                    <option value="">Any Room</option>
                                    {ratemetricsRoomtypes?.map((item, idx) => (
                                        <option key={idx} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div className=" no-border-break ">
                                <Form.Select id={commonService.generateGlobalClickTrackerID("RMRateShop", "CompSet-Type-form-select-onchange", "")} aria-label="Select CompSet Type" value={RateshopPara.CompSetType}
                                    onChange={(e) => {
                                        setRateshopPara({
                                            ...RateshopPara,
                                            CompSetType: e.target.value,
                                        });
                                    }}
                                >
                                    <option value="">Any CompSet Type</option>
                                    {compsetTypeList?.map((item, idx) => (
                                        <option key={idx} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div className=" no-border-break ">
                                <button id={commonService.generateGlobalClickTrackerID("RMRateShop", "my-request-status", "")}
                                    className="default-btn secondary-btn me-1"
                                    type="button"
                                    onClick={() => {
                                        if (api === 0) return;
                                        setRequestStatusModal(true);
                                    }}
                                >
                                    My Request Status
                                </button>
                            </div>
                        </div>
                    </Row>

                    <Row className="fullCustomCalendarMain-and-all-hotels-main">
                        <Col xl={10}>
                            {
                                loading ? (<Loader />) : (
                                    <div className="fullCustomCalendarMain">
                                        <div className="fullCustomCalendarMain">
                                            <div className="fullCustomCalendarTable">
                                                <div className="calendar-container">
                                                    <div className="calendar-header"></div>
                                                    <Row className="fullCustomCalendarMainWrapper align-items-center">
                                                        <Col xl={3}>
                                                            <div style={{ display: "flex" }}>
                                                                <div className="allDateDetailPercentInner">
                                                                    <div style={{ background: "#008000" }}></div>
                                                                    <p>OTB</p>
                                                                </div>
                                                                <div className="allDateDetailPercentInner">
                                                                    <div style={{ background: "#0000FF" }}></div>
                                                                    <p>Forecast</p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xl={3}>
                                                            <div
                                                                className="month-name-with-arrow mb-0"
                                                                style={{ justifyContent: "center", marginLeft: 0 }}
                                                            >
                                                                <button id={commonService.generateGlobalClickTrackerID("RMRateShop", "premonth-button-onclick", "")}
                                                                    onClick={() => {
                                                                        let d = new Date(dateRange?.start);
                                                                        d.setMonth(d.getMonth() - 1);
                                                                        const startDate =
                                                                            commonService.getDateInDBFormat(
                                                                                new Date(d.getFullYear(), d.getMonth(), 1)
                                                                            );
                                                                        const endDate = commonService.getDateInDBFormat(
                                                                            new Date(d.getFullYear(), d.getMonth() + 1, 0)
                                                                        );
                                                                        setDateRange({
                                                                            start:
                                                                                commonService.convertDateInTimezone(
                                                                                    startDate
                                                                                ),
                                                                            end: commonService.convertDateInTimezone(
                                                                                endDate
                                                                            ),
                                                                        });
                                                                        handlePrevMonth();
                                                                    }}
                                                                >
                                                                    <img src={premonth} alt="premonth" />
                                                                </button>
                                                                <h4>
                                                                    {currentDate.toLocaleDateString("en-US", {
                                                                        month: "long",
                                                                        year: "numeric",
                                                                    })}
                                                                </h4>
                                                                <button id={commonService.generateGlobalClickTrackerID("RMRateShop", "nextmonth-button-onclick", "")}
                                                                    onClick={() => {
                                                                        let d = new Date(dateRange?.start);
                                                                        d.setMonth(d.getMonth() + 1);
                                                                        const startDate =
                                                                            commonService.getDateInDBFormat(
                                                                                new Date(d.getFullYear(), d.getMonth(), 1)
                                                                            );
                                                                        const endDate = commonService.getDateInDBFormat(
                                                                            new Date(d.getFullYear(), d.getMonth() + 1, 0)
                                                                        );
                                                                        setDateRange({
                                                                            start:
                                                                                commonService.convertDateInTimezone(
                                                                                    startDate
                                                                                ),
                                                                            end: commonService.convertDateInTimezone(
                                                                                endDate
                                                                            ),
                                                                        });
                                                                        handleNextMonth();
                                                                    }}
                                                                >
                                                                    <img src={nextmonth} alt="nextmonth" />
                                                                </button>
                                                            </div>
                                                        </Col>
                                                        <Col xl={6}>
                                                            <div className="allDateDetailPercent justify-content-between">
                                                                {colorComparisonData?.map((item, index) => (
                                                                    <div
                                                                        key={item?.ratecomparisonid}
                                                                        className="allDateDetailPercentInner"
                                                                    >
                                                                        <div
                                                                            style={{ background: item?.indicatorcolor }}
                                                                        ></div>
                                                                        <p>
                                                                            {item?.minper}% - {item?.maxper}%
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <table className="calendar-table" onMouseLeave={(e) => {
                                                        setShowToolTip({
                                                            IsDisplay: false,
                                                            Target: null,
                                                            Position: "top",
                                                            Date: "",
                                                            Data: {}
                                                        });
                                                    }}>
                                                        <thead>
                                                            <tr>
                                                                {daysOfWeek.map((day) => (
                                                                    <th key={day}>{day}</th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody >
                                                            {rateShopList && renderCalendar(currentDate)}
                                                        </tbody>
                                                        {showSingleTicketPopUp && (
                                                            <div
                                                                className="ToolsSingleTicketMain"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: `${popupPosition.top}px`,
                                                                    left: `${popupPosition.left}px`,
                                                                    // transform: "translate(-76%, -21%)",
                                                                }}
                                                            >
                                                                <ToolsSingleTicketPopUp
                                                                    closeSingleTicketPopUp={closeSingleTicketPopUp}
                                                                    date={dateRef.current}
                                                                />
                                                            </div>
                                                        )}


                                                        <Overlay
                                                            show={ShowToolTip.IsDisplay}
                                                            target={ShowToolTip.Target}
                                                            placement={ShowToolTip.Position}
                                                        >
                                                            <Popover
                                                                id="popover-contained"
                                                                className="SingleDateSummaryModalPopoverMain p-3 width500"
                                                            >
                                                                {ShowToolTip.IsDisplay && (
                                                                    <>
                                                                        <div className="dateWithArrowBottom-cal-tooltip">
                                                                            <div className="myRateCardsMain">
                                                                                <p>My Price</p>
                                                                                <p>
                                                                                    {ShowToolTip.Data?.isSelf?.rate
                                                                                        ? `${commonService.formateAmount(
                                                                                            Math.round(ShowToolTip.Data?.isSelf?.rate)
                                                                                        )}`
                                                                                        : ""}
                                                                                </p>
                                                                            </div>
                                                                            <div
                                                                                className="myRateCardsMain"
                                                                                style={{ background: "#E0F2E9" }}
                                                                            >
                                                                                <p>Min Rate</p>
                                                                                <p>
                                                                                    {ShowToolTip.Data?.min
                                                                                        ? `${commonService.formateAmount(
                                                                                            Math.round(ShowToolTip.Data?.min)
                                                                                        )}`
                                                                                        : ""}
                                                                                </p>
                                                                            </div>
                                                                            <div
                                                                                className="myRateCardsMain"
                                                                                style={{ background: "#FFF6E0" }}
                                                                            >
                                                                                <p>Avg Rate</p>
                                                                                <p>
                                                                                    {ShowToolTip.Data?.total
                                                                                        ? `${commonService.formateAmount(
                                                                                            Math.round(
                                                                                                ShowToolTip.Data?.total /
                                                                                                ShowToolTip.Data?.lengthForAvg
                                                                                            )
                                                                                        )}`
                                                                                        : ""}
                                                                                </p>
                                                                            </div>
                                                                            <div
                                                                                className="myRateCardsMain"
                                                                                style={{ background: "#FCE5E2" }}
                                                                            >
                                                                                <p>Max Rate</p>
                                                                                <p>
                                                                                    {ShowToolTip.Data?.max
                                                                                        ? `${commonService.formateAmount(
                                                                                            Math.round(ShowToolTip.Data?.max)
                                                                                        )}`
                                                                                        : ""}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="ToolsSummaryPopUpTable">
                                                                            <div className="table__container">
                                                                                <div className="stripped__table">
                                                                                    <Table id="SummaryPopUpTbl" responsive>
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th className="">Competitors</th>
                                                                                                <th className="text-end">Price</th>
                                                                                                <th className="text-end">Change</th>
                                                                                                <th className="text-end">Variance</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {ShowToolTip.Data &&
                                                                                                Object.entries(ShowToolTip.Data)?.map(
                                                                                                    ([key, value]) => {

                                                                                                        let variance = (ShowToolTip.Data?.isSelf?.rate ? ShowToolTip.Data?.isSelf?.rate : 0) - (value?.rate ? value?.rate : 0);
                                                                                                        let Change = value.RateDifference ? parseInt(value.RateDifference) : 0;

                                                                                                        return (
                                                                                                            <React.Fragment key={key}>
                                                                                                                {key !== "isSelf" &&
                                                                                                                    key !== "total" &&
                                                                                                                    key !== "max" &&
                                                                                                                    key !== "min" &&
                                                                                                                    key !== "lengthForAvg" && (
                                                                                                                        <tr>
                                                                                                                            <td>{key}</td>
                                                                                                                            <td className="text-end">
                                                                                                                                {parseInt(value?.RateStatusCode) === 201 ? (
                                                                                                                                    <img
                                                                                                                                        className="cursorPointer"
                                                                                                                                        src={soldOutIcon}
                                                                                                                                        alt="soldout"
                                                                                                                                    />
                                                                                                                                ) : (

                                                                                                                                    value?.rate
                                                                                                                                        ? <span title={`${parseFloat(value?.rate) <= 0 && value?.RateStatusDesc ? value?.RateStatusDesc : ""}`}>{`${commonService.formateAmount(Math.round(value?.rate))}`}</span>
                                                                                                                                        : <span title={`${value?.RateStatusDesc ? value?.RateStatusDesc : ""}`}>{`${commonService.formateAmount(0)}`}</span>

                                                                                                                                )}
                                                                                                                            </td>
                                                                                                                            <td className={`text-end ${Change < 0 ? "redText" : "greenText"}`}>
                                                                                                                                {Change !== 0 ? commonService.formateAmount(Change) : ""}
                                                                                                                            </td>
                                                                                                                            <td className={`text-end ${variance < 0 ? "greenText" : "redText"}`}>
                                                                                                                                {commonService.formateAmount(variance)}
                                                                                                                            </td>
                                                                                                                        </tr>
                                                                                                                    )}
                                                                                                            </React.Fragment>
                                                                                                        );
                                                                                                    }
                                                                                                )}
                                                                                        </tbody>
                                                                                    </Table>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </Popover>
                                                        </Overlay>
                                                    </table>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </Col>
                        <Col xl={2}>
                            <div className="rateShopRightMainContainer">
                                {competitorList &&
                                    competitorList?.map((item, index) => (
                                        <div
                                            key={index}
                                            className="rateShopRightMain"
                                            style={{
                                                backgroundImage: `${item?.thumbnailimage
                                                    ? item?.thumbnailimage
                                                    : `url(${placeHolder})`
                                                    }`,
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "contain",
                                                backgroundPosition: "center",
                                            }}
                                        >
                                            {item?.isself !== true ? (
                                                <div className="singleCheckBox">
                                                    <Form.Check id={commonService.generateGlobalClickTrackerID("RMRateShop", "competiterpropertyname-form-check-onchange", item)}
                                                        checked={
                                                            selectedCompetitorList[
                                                            item?.competiterpropertyname
                                                            ]
                                                        }
                                                        onChange={(e) => {
                                                            selectedCompetitorListRef.current[
                                                                item?.competiterpropertyname
                                                            ] =
                                                                !selectedCompetitorList[
                                                                item?.competiterpropertyname
                                                                ];
                                                            setSelectedCompetitorList(
                                                                selectedCompetitorListRef.current
                                                            );

                                                            calculateCalDetail();
                                                        }}
                                                        aria-label="option 1"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="rateShopSelfTag">Self</div>
                                            )}


                                            <p>
                                                {item?.isself
                                                    ? `${item?.competiterpropertyname}`
                                                    : item?.competiterpropertyname}
                                            </p>
                                        </div>
                                    ))}

                            </div>
                        </Col>
                    </Row>

                    <div className="snapshotrow" rowtitle="Rate Shop" style={{ display: "none" }}>
                        <Table id={tblids.RateShopTable}>
                            <thead className="tbl-header-sticky">
                                <tr>
                                    <th className="width150">DATE</th>
                                    <th className="width150" style={{ display: "none" }}>EVENTS</th>
                                    <th className="width100">MY PRICE</th>
                                    <th className="width100">DIFF</th>
                                    <th className="width100">{diffType.toUpperCase()}</th>
                                    {
                                        competitorList &&
                                        competitorList?.map((item, index) => (
                                            selectedCompetitorList[item.competiterpropertyname] && !item?.isself &&
                                            <th>{item.competiterpropertyname}</th>
                                        ))
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {rateShopList ? (
                                    Object.entries(rateShopList)?.map(([key, value]) => {
                                        let d = commonService.convertDateInTimezone(
                                            dateRange.start
                                        );
                                        d.setDate(key);
                                        let diffValue = 0,
                                            findDiffFromCal = 0,
                                            tdDiffValue = 0,
                                            bgColorDiffWise = "";
                                        const tableDateKey = calendarDateKey(d);
                                        let checkEvent = eventsByDate[tableDateKey] || [];
                                        let checkReminder = remindersByDate[tableDateKey] || [];
                                        let checkSoldOut = soldOutByDate[tableDateKey] || [];


                                        if (diffType === "avg") {
                                            if (value?.isSelf?.rate > 0 && value?.total > 0) {
                                                let avgValue =
                                                    value?.total / value?.lengthForAvg;
                                                tdDiffValue = Math.round(avgValue);
                                                findDiffFromCal = Math.round(
                                                    value?.isSelf?.rate - avgValue
                                                );
                                                diffValue = Math.round(
                                                    (findDiffFromCal * 100) / value?.isSelf?.rate
                                                );
                                            }
                                        } else if (diffType === "max") {
                                            if (value?.isSelf?.rate > 0 && value?.max > 0) {
                                                tdDiffValue = Math.round(value?.max);
                                                findDiffFromCal = Math.round(
                                                    value?.isSelf?.rate - tdDiffValue
                                                );
                                                diffValue = Math.round(
                                                    (findDiffFromCal * 100) / value?.isSelf?.rate
                                                );
                                            }
                                        } else if (diffType === "min") {
                                            if (value?.isSelf?.rate > 0 && value?.min > 0) {
                                                tdDiffValue = Math.round(value?.min);
                                                findDiffFromCal = Math.round(
                                                    value?.isSelf?.rate - tdDiffValue
                                                );
                                                diffValue = Math.round(
                                                    (findDiffFromCal * 100) / value?.isSelf?.rate
                                                );
                                            }
                                        }
                                        bgColorDiffWise = getComparisonColor(diffValue, false);

                                        let findOccPercenatge = forecastByDate[tableDateKey] || [];
                                        return (
                                            <tr key={key} className="shadowOnHover">
                                                <td>
                                                    <div className="d-flex align-items-center gap-4">
                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                background:
                                                                    GetRateshopCalendarCellColor(
                                                                        findOccPercenatge?.[0]
                                                                            ?.OCC_Percentage
                                                                    ),
                                                                padding: "3px",
                                                            }}

                                                        >
                                                            {commonService.getDateInFormat(
                                                                commonService.convertDateInTimezone(d)
                                                            )}
                                                        </div>

                                                        <div className="d-flex justify-content-between align-items-center gap-2 ticketAlarmReload">
                                                            {checkEvent?.length > 0 && (
                                                                <img
                                                                    src={ticket}
                                                                    className="iconcolor"
                                                                    alt="ticket"

                                                                />
                                                            )}
                                                            {checkReminder?.length > 0 && (
                                                                <img
                                                                    className="iconcolor"
                                                                    src={alarm}
                                                                    alt="ticket"

                                                                />
                                                            )}
                                                            {checkSoldOut?.length > 0 && (
                                                                <img
                                                                    className=""
                                                                    src={soldOutIcon}
                                                                    alt="soldOut"
                                                                />
                                                            )}

                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ display: "none" }}>
                                                    {checkEvent?.length > 0 && (
                                                        checkEvent.map((item, index) => (
                                                            <><span>{index + 1}) {item.name}</span><br /></>
                                                        ))
                                                    )}
                                                </td>
                                                <td>
                                                    <span
                                                        className="default-badge"
                                                        style={{ background: bgColorDiffWise }}
                                                    >
                                                        {value?.isSelf?.rate
                                                            ? `${commonService.formateAmount(
                                                                Math.round(value?.isSelf?.rate)
                                                            )}`
                                                            : `${commonService.formateAmount(0)}`}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="d-flex  align-items-center">
                                                        {commonService.formateAmount(
                                                            Math.abs(findDiffFromCal)
                                                        )}{" "}
                                                        /{" "}
                                                        <div
                                                            style={{
                                                                height: "25px",
                                                                width: "25px",
                                                                backgroundColor: bgColorDiffWise,
                                                                borderRadius: "50%",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                padding: "3px",
                                                            }}
                                                        >
                                                            <small style={{ fontSize: "10px" }}>
                                                                {Math.abs(diffValue)}%
                                                            </small>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {commonService.formateAmount(
                                                        Math.round(tdDiffValue)
                                                    )}
                                                </td>

                                                {
                                                    competitorList &&
                                                    competitorList?.map((item, index) => (
                                                        selectedCompetitorList[item.competiterpropertyname] && !item?.isself &&
                                                        <td>{value[item.competiterpropertyname]?.rate ? commonService.formateAmount(Math.round(value[item.competiterpropertyname]?.rate)) : commonService.formateAmount(0)}</td>
                                                    ))
                                                }
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>No Data Found</tr>
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <AddCompetitorModal
                        showAddCompetitorModal={showAddCompetitorModal}
                        closeAddCompetitorModal={closeAddCompetitorModal}
                    />
                    {showToolsSummaryModal && (
                        <ToolsSummaryModalByFilter
                            showToolsSummaryModal={showToolsSummaryModal}
                            closeToolsSummaryModal={closeToolsSummaryModal}
                            selectedDate={ClickedDate}
                            propertyDetail={propertyDetailFromRTK}
                            Compare={Compare}
                            RateshopPara={RateshopPara}
                        />
                    )}
                    <GroupReservationsModal
                        showGroupReservationsModal={showGroupReservationsModal}
                        closeGroupReservationsModal={closeGroupReservationsModal}
                    />
                </Container>
            ) : (
                <Container>
                    <div className="d-flex justify-content-center">
                        <h5>Please Select Property</h5>
                    </div>
                </Container>
            )}
            {showEventModal && (
                <AddEventModal
                    showModal={showEventModal}
                    closeModal={closeEventModal}
                    eventId={0}
                    propertyId={propertyId}
                />
            )}

            {showReminderModal && (
                <AddReminderModal
                    showModal={showReminderModal}
                    closeModal={closeReminderModal}
                    reminderid={0}
                    propertyid={
                        propertyId
                            ? parseInt(propertyId)
                            : 0
                    }
                />
            )}
            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={closeTicketModal}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={selectedEventDateRef.current}
                    getEventList={getEventList}
                />
            )}
            {viewReminderModal && (
                <ToolsSingleTicketPopUp
                    showModal={viewReminderModal}
                    closeModal={closeViewReminderModal}
                    eventDetails={reminderListPropsRef.current}
                    isReminder={isReminderRef.current}
                />
            )}
            {showAdrChart && (
                <RateShopGraphView
                    showModal={showAdrChart}
                    closeModal={closeAdrChart}
                />
            )}

            <Overlay
                show={showModal.IsDisplay}
                target={showModal.Target}
                placement={showModal.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                >
                    <div
                        className="vertical-menu-option"
                        style={{ borderRadius: "10px" }}
                    >
                        <p id={commonService.generateGlobalClickTrackerID("RMRateShop", "reminder", "")}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setShowReminderModal(true);
                                setShowModal({
                                    IsDisplay: false,
                                    Target: null,
                                    Position: "bottom",
                                });
                            }}
                        >
                            Reminder
                        </p>
                        <p id={commonService.generateGlobalClickTrackerID("RMRateShop", "event", "")}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setShowEventModal(true);
                                setShowModal({
                                    IsDisplay: false,
                                    Target: null,
                                    Position: "bottom",
                                });
                            }}
                        >
                            Event
                        </p>
                        {isRateShopSoldOutRef.current?.length > 0 ? (
                            <p id={commonService.generateGlobalClickTrackerID("RMRateShop", "unsold", "")}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    unsoldOut(isRateShopSoldOutRef.current);
                                }}
                            >
                                Unsold
                            </p>
                        ) : (
                            <p id={commonService.generateGlobalClickTrackerID("RMRateShop", "sold-out", "")}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    soldOut();
                                }}
                            >
                                Sold Out
                            </p>
                        )}
                    </div>
                </Popover>
            </Overlay>

            {widgetModal && (
                <Non_WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    non_widgetname={"Rate Shop"}
                />
            )}

            {requestStatusModal && (
                <OnDemandRateshopRequestStatusModal
                    showModal={requestStatusModal}
                    closeModal={() => setRequestStatusModal(false)}
                    propertyId={propertyId}
                    startdate={commonService.getDateInDBFormat(dateRange?.start)}
                    enddate={commonService.getDateInDBFormat(dateRange?.end)}
                />
            )}
        </div>
    );
}

export default RMRateShop;
